import { Column, CreateDateColumn, Entity, JoinColumn, ManyToOne, OneToMany, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";
import { FixedComponentsRateChartLogs } from "./fixed-components-log-entity";
import { FixedComponentsCategoryEnum } from "libs/shared-models/masters/src/lib/fixed-components-rate-chart";
import { PackingCategoryEnum } from "../../../../../../libs/shared-models/common-models/src/lib/enum/packing-category.enum";

@Entity('fixed_prices_chart')
export class FixedComponentsRateChart{
    @PrimaryGeneratedColumn("increment",{name:'id'})
    id:number;

    @Column("varchar",{
        nullable: false,
        length:100,
        name: "component"
      })
      component: string;  
      
      @Column({
        type:"decimal",precision:10,scale:2,
        nullable: false,
        name: "price"
      })
       price: number;  
       @CreateDateColumn({
        name: "created_at",
        type: "datetime"
      })
      createdAt: Date;
    
      @Column("varchar", {
    nullable: true,
    name: "created_user"
  })
  createdUser: string | null;

  @UpdateDateColumn({
    name: "updated_at",
    type: 'datetime'
  })
  updatedAt: Date;

  @Column("varchar", {
    nullable: true,
    name: "updated_user"
  })
  updatedUser: string | null;

  
  @Column("boolean", {
    default: true,
    name: "is_active"
  })
  isActive: boolean;

  @VersionColumn({
    default: 1,
    name: "version_flag"
  })
  versionFlag: number;

  @Column({
    type:'enum',
    nullable: false,
    name: "category",
    enum:FixedComponentsCategoryEnum
  })
  category: FixedComponentsCategoryEnum;
  
  
  @Column({
    type:'enum',
    nullable: false,
    name: "packing_category",
    enum:PackingCategoryEnum
  })
  packingCategory: PackingCategoryEnum;

  @OneToMany(type => FixedComponentsRateChartLogs, info => info.RefId, { cascade: true })
  logs: FixedComponentsRateChartLogs[];
  

}